import {
  BOAT_SELECT_TYPE,
  BOAT_SELECT_ENGINE_TYPE,
  BOAT_SET_DETAILS_SUCCESS,
  BOAT_SET_DETAILS_ERROR, BOAT_CLEAR_DETAILS, BOAT_UPDATE_DETAILS
} from '../actionTypes';
import {
  BOAT,
  CANOE_KAYAK,
  CATAMARAN,
  INFLATABLE,
  JON_BOAT,
  PONTOON,
  PWC, SAILBOAT,
  YACHT
} from '../../constants/boatApplication';
import Boat from '../models/Boat';
import Yacht from '../models/Yacht';
import Canoe from '../models/Canoe';
import Catamaran from '../models/Catamaran';
import Inflatable from '../models/Inflatable';
import JonBoat from '../models/JonBoat';
import Pontoon from '../models/Pontoon';
import Pwc from '../models/Pwc';
import SailBoat from '../models/SailBoat';
import BaseBoat from '../models/BaseBoat';

const initState = {
  id: 'new',
  boatType: null,
  status: 'DRAFT',
  engineType: null,
  powerCapacity: {},
  cubicCapacity: {},
  boatSystems: [],
  personPowerCapacity: {},
  bottomContourList: [],
  engineTypesList: [],
  engineSubTypesList: [],
  floatationCapacity: {},
  boatSpecifications: {}
};

export default (state = initState, action) => {
  const _createBoat = data => {
    switch (data.boatType) {
      case BOAT:
        return new Boat(data);
      case YACHT:
        return new Yacht(data);
      case CANOE_KAYAK:
        return new Canoe(data);
      case CATAMARAN:
        return new Catamaran(data);
      case INFLATABLE:
        return new Inflatable(data);
      case JON_BOAT:
        return new JonBoat(data);
      case PONTOON:
        return new Pontoon(data);
      case PWC:
        return new Pwc(data);
      case SAILBOAT:
        return new SailBoat(data);
      default:
        return new BaseBoat(data);
    }
  };

  const _updateDualSteering = () => {
    if (action.payload.dualSteering === undefined || action.payload.dualSteering === state.dualSteering) {
      return {};
    } else {
      return {
        reqMaxHPDualSteering: action.payload.dualSteering ? '' : undefined,
        calcMaxHPDualSteering: action.payload.dualSteering ? '' : undefined,
        apprMaxHPDualSteering: action.payload.dualSteering ? '' : undefined
      };
    }
  };

  switch (action.type) {
    case BOAT_SELECT_TYPE:
      if (action.payload !== state.boatType) {
        return _createBoat({...initState, boatType: action.payload});
      } else {
        return {...state};
      }
    case BOAT_SELECT_ENGINE_TYPE:
      if (action.payload !== state.engineType) {
        return _createBoat({...initState, boatType: state.boatType, engineType: action.payload});
      } else {
        return {...state, engineType: action.payload};
      }
    case BOAT_SET_DETAILS_SUCCESS:
      return _createBoat({...action.payload});
    case BOAT_SET_DETAILS_ERROR:
    case BOAT_CLEAR_DETAILS:
      return {...initState};
    case BOAT_UPDATE_DETAILS:
      return {
        ...state, ...action.payload,
        personPowerCapacity: {
          ...(action.payload.personPowerCapacity ? action.payload.personPowerCapacity : state.personPowerCapacity),
          ..._updateDualSteering()
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/boat.js